import React, { useState } from "react";
import request from "request";
import Card from "Card";
import Input from "Input";
import Button from "Button";
import Select from "Select";
import Modal from "Modal";
import PrepaidCreditCard from "./PrepaidCreditCard";

const CreateCreditTab = ({ venues, fetchCredits, dataSource = "internal" }) => {
  const [newCredit, setNewCredit] = useState({
    code: "",
    initialBalanceCents: "",
    venueId: "",
    expiresAt: ""
  });
  const [createdCredit, setCreatedCredit] = useState(null);

  const updateNewCredit = (field, value) => {
    setNewCredit({
      ...newCredit,
      [field]: value
    });
  };

  const generateRandomCode = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    for (let i = 0; i < 8; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    setNewCredit({
      ...newCredit,
      code: result
    });
  };

  const handleCreateCredit = () => {
    if (!newCredit.code || !newCredit.initialBalanceCents || (dataSource === "internal" && !newCredit.venueId)) {
      alert("Please fill all required fields");
      return;
    }

    // Convert dollars to cents
    const balanceCents = Math.round(parseFloat(newCredit.initialBalanceCents) * 100);

    const creditData = {
      prepaid_credit: {
        code: newCredit.code,
        initialBalanceCents: balanceCents,
        venueId: dataSource === "internal" ? newCredit.venueId : null,
        currentBalanceCents: balanceCents,
        expiresAt: newCredit.expiresAt || null
      }
    };

    let req = request.post(`${dataSource}/prepaid_credits`, creditData);
    req.then(({data}) => {
      if (data.success) {
        setNewCredit({
          code: "",
          initialBalanceCents: "",
          venueId: "",
          expiresAt: ""
        });
        fetchCredits();
        setCreatedCredit(data.credit);
      } else if (data.errors) {
        alert(`Error creating credit: ${data.errors.join(", ")}`);
      }
    }).catch(error => {
      alert(`Error creating credit: ${error.message}`);
    });
  };

  const closeModal = () => setCreatedCredit(null);

  return (
    <div className="column is-12">
      <Card title="Create Credit">
        <div className="columns is-multiline">
          <div className="column is-6">
            <div className="field">
              <label className="label">Credit Code*</label>
              <div className="field has-addons">
                <div className="control is-expanded">
                  <Input
                    placeholder="Enter credit code"
                    value={newCredit.code}
                    onChange={(value) => updateNewCredit("code", value)}
                  />
                </div>
                <div className="control">
                  <Button
                    onClick={generateRandomCode}
                    text="Generate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="column is-6">
            <div className="field">
              <label className="label">Initial Balance (in dollars)*</label>
              <div className="control">
                <Input
                  type="number"
                  step="0.01"
                  placeholder="Enter amount"
                  value={newCredit.initialBalanceCents}
                  onChange={(value) => updateNewCredit("initialBalanceCents", value)}
                />
              </div>
            </div>
          </div>
          {dataSource === "internal" && (
            <div className="column is-6">
              <Select
                label="Venue*"
                options={venues ? venues.reduce((obj, venue) => {
                  obj[venue.id] = `${venue.accountName || ''} - ${venue.name}`;
                  return obj;
                }, {}) : {}}
                prompt="Select venue"
                value={newCredit.venueId}
                onChange={(value) => updateNewCredit("venueId", value)}
              />
            </div>
          )}
          <div className="column is-6">
            <div className="field">
              <label className="label">Expiry Date (Optional)</label>
              <div className="control">
                <Input
                  type="date"
                  value={newCredit.expiresAt}
                  onChange={(value) => updateNewCredit("expiresAt", value)}
                />
              </div>
            </div>
          </div>
        </div>

        <Button
          className="is-primary is-fullwidth"
          onClick={handleCreateCredit}
          disabled={!newCredit.code || !newCredit.initialBalanceCents || (dataSource === "internal" && !newCredit.venueId)}
          icon="plus"
          text="Create Credit"
        />
      </Card>

      {createdCredit && (
        <Modal
          isOpen
          toggleModal={closeModal}
          title="Credit Created"
          actions={
            <Button className="is-primary" onClick={closeModal} text="Done" />
          }
        >
          <PrepaidCreditCard credit={createdCredit} />
        </Modal>
      )}
    </div>
  );
};

export default CreateCreditTab;
